import { Injectable } from '@angular/core';
import { Router, NavigationStart, NavigationEnd} from '@angular/router';
import { RouteLoggerService } from './route-logger.service';
import { ConfigurationService } from './configuration.service';
import { Configuration } from './configuration.model';


@Injectable()
export class RouteLoggerServiceImpl implements RouteLoggerService {
    startTime: any;
    configuration: Configuration;

    constructor(private router: Router,
        private configService: ConfigurationService) {
        this.configuration = this.configService.configuration;

        this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                // appInsights.trackEvent("router event started", { url: event.url });
                this.startTime = new Date();
            }
            if (event instanceof NavigationEnd) {
                // appInsights.trackEvent("router event ended", { url: event.url });

                const now: any = new Date();
                const durationMs: number = Math.abs(now - this.startTime);
                appInsights.trackPageView(this.configuration.tool, event.url, null, null, durationMs);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/route-logger-impl.service.ts